import { gql as contentfulGQL } from '@apollo/client'
import { ContentfulClientOptions, getContentfulClient } from '@/services/ApolloClient'
import { Collection } from '@/types/codegen-contentful'
import { isStagingEnvironment } from '@/utils/environment-utils'
import { logger } from '@/utils/logging'

export const OUR_IMPACT_ENTRY_ID = isStagingEnvironment() ? '1OaQz9YU5Wbrklw90Z2Wqi' : '3Qfw4wtQcasJnK8An35iXI'
export const WATCH_FOR_FREE_ENTRY_ID = isStagingEnvironment() ? '3ywfXPqwU8LbFPBaFuMrP5' : '5NPEcTQ5wrJvclQOiHVQFO'
export const SNEAK_PEEK_ENTRY_ID = isStagingEnvironment() ? '4dxVjGDZiGVMGXemGVokus' : '4k3ugMm8cJE8ZcI5IBptJh'
export const GUILD_MEMBERSHIP_NUMBERS_ID = isStagingEnvironment() ? '1KSngT4sjFXLhM9UfGZMCc' : '6jIe1S7pgjYmMceUTUTdS1'
export const UNIQUE_SHARE_CLAIM_USERS_ID = isStagingEnvironment() ? '4hm2I4VmYNRJT1CQ5R1VcL' : 'Y7vYNWDSCetjgx7RvzZsd'
export const SNEAK_PEEK_TO_PRIMARY_ENTRY_ID = isStagingEnvironment()
  ? '3VvkEDsvQOrEfAet9oTnuE'
  : 'Lv5pDgsKfa5JxKdOFxSlU'
export const GUILD_PREDICTS_WINNERS_ENTRY_ID = isStagingEnvironment()
  ? '3csfc4LSsLQoDV1p0lgEx'
  : '5tK2EAela2ILaU9tLWSD6W'
export const FILMMAKER_PAYOUT_NUMBERS = isStagingEnvironment() ? '6zv9NGkZpQW4Ij5aZtOuZY' : '7f0c1VKqOzYQDiPsnBwBZ7'
export const EXCLUSIVE_SCENE_VIDEOS_ASSETS_ENTRY_ID = isStagingEnvironment()
  ? '2gWz4IOv4RwIcimNW0g2ZJ'
  : '3p4j6cpH4zYGZXeFc2rmlu'
export const MUSIC_PAGE_ASSETS_ENTRY_ID = isStagingEnvironment() ? '4zSa8dWehDrOboAgZRi2oz' : '2ml70N1JKVUPV8iIMoaTD'

export const GET_COLLECTION_QUERY = contentfulGQL/* GraphQL */ `
  query getCollectionById($id: String!, $locale: String, $preview: Boolean) {
    collection(id: $id, locale: $locale, preview: $preview) {
      customData
      dataSource
      displayAs
      name
    }
  }
`

export async function getCollection(opts: ContentfulClientOptions, id: string): Promise<Collection | undefined> {
  try {
    const { data } = await getContentfulClient(opts).query({
      query: GET_COLLECTION_QUERY,
      variables: { id, locale: opts?.locale, preview: opts?.preview },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    })

    return data.collection
  } catch (error) {
    logger().error(`Error fetching collection with id: ${id}`, { id, opts, error })
    return undefined
  }
}
